import React from "react";
import styles from "./LoadingOverLay.module.sass"
import Loader from "../../../../components/Loader";
const LoaderOverlay = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className={styles.overlay}>
         <Loader className={styles.loader} white={"white"} />
    </div>
  );
};

export default LoaderOverlay;
